// Edit a deficiency site's note: its handling status and free text, with the earlier versions below.
// Everyone with access to the road sees and edits it (the server checks); every save is a new version.
import React, { useEffect, useState } from 'react';
import { Modal } from '../Overview/OverviewDialogs';
import { ANALYSIS_NAMES } from '../Overview/overviewModel';
import { MAX_NOTE, NOTE_STATUSES, STATUS_COLOR, STATUS_LABEL, fetchNoteHistory } from './siteNotes';

export function StatusChip({ status }) {
  if (!status) return null;
  return <span className="so-note-chip" style={{ background: STATUS_COLOR[status] || '#64748b' }}>{STATUS_LABEL[status] || status}</span>;
}

export default function SiteNoteDialog({ site, segment, current, onSave, onClose }) {
  const [status, setStatus] = useState(current ? current.status : 'open');
  const [text, setText] = useState(current ? current.note : '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [history, setHistory] = useState(null);
  useEffect(() => {
    if (!current || current.versions < 2) return undefined;
    let live = true;
    fetchNoteHistory(segment, current).then((h) => { if (live) setHistory(h); }).catch(() => { if (live) setHistory([]); });
    return () => { live = false; };
  }, [current, segment]);
  const save = async () => {
    setBusy(true);
    setError('');
    try {
      await onSave(status, text.trim());
      onClose();
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };
  const where = `${site.road}${site.segment ? ` · ${site.segment}` : ''} · ${site.direction === 'P' ? 'positive' : 'negative'} direction · MP ${(site.mpStart ?? 0).toFixed(2)}`;
  return (
    <Modal title="Site note" onClose={onClose}>
      <p className="safety-muted so-note-where">{site.analysis} · {ANALYSIS_NAMES[site.analysis]} · {where}</p>
      <label className="safety-filter" htmlFor="so-note-status"><span>Status</span>
        <select id="so-note-status" value={status} onChange={(e) => setStatus(e.target.value)}>
          {NOTE_STATUSES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </label>
      <label className="safety-filter so-note-text" htmlFor="so-note-text"><span>Note</span>
        <textarea id="so-note-text" rows={5} maxLength={MAX_NOTE} value={text} onChange={(e) => setText(e.target.value)}
          placeholder="What was found, what is planned, who handles it…" />
        <small className="safety-muted">{text.length} / {MAX_NOTE} · seen and edited by everyone with access to this road</small>
      </label>
      {current && <p className="safety-muted so-note-last">Last saved by {current.author} on {current.at}</p>}
      {error && <div className="safety-error">{error}</div>}
      <div className="row-actions so-note-actions">
        <button type="button" className="safety-btn safety-btn-ghost" onClick={onClose} disabled={busy}>Cancel</button>
        <button type="button" className="safety-btn ov-primary" onClick={save} disabled={busy}>{busy ? 'Saving…' : 'Save note'}</button>
      </div>
      {history && history.length > 1 && (
        <details className="so-note-history">
          <summary>Earlier versions ({history.length - 1})</summary>
          <ul>
            {history.slice(1).map((h) => (
              <li key={h.id}><StatusChip status={h.status} /> <b>{h.author}</b> · {h.at}{h.note ? <div>{h.note}</div> : null}</li>
            ))}
          </ul>
        </details>
      )}
    </Modal>
  );
}
